import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {GlobalModule} from "../../../global-module/global-module.module";
import {CashierPage} from "./cashier.page";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {AdminGlobalModule} from "../../admin-global-module.module";
import {RouterModule, Routes} from "@angular/router";

const routes: Routes = [
    {
        path: '',
        component: CashierPage
    }
];

@NgModule({
    imports: [
        ScrollingModule,
        CommonModule,
        FormsModule,
        GlobalModule,
        AdminGlobalModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    exports: [],
    declarations: [CashierPage]
})
export class CashierPageModule {
}